// Build-time nutrient loader
// This module embeds the CSV data directly in the bundle for optimal performance

import { NutrientData } from '../utils/parseCsvNutrients';

// Embedded CSV data (auto-generated from nutrient_data.csv)
// This is bundled at build time, avoiding any runtime fetch overhead
const NUTRIENT_CSV_DATA = `fish_id,protein,fat,energy,calcium,iron,zinc,iodine,sodium,potassium,magnesium,phosphorus,copper,manganese,sulphur,selenium,vitaminA,vitaminD,vitaminE,thiamin,riboflavin,niacin,vitaminB6,folate,vitaminB12,omega3
bheda,18.1,2.96,718.59,2.57,6.42,11.93,13,0.46,3.04,0.23,2.88,0.001,0.001,210,0.004,60,0.78,0.36,1,1,1,1,3.5,0.9,219.06
katla,17.68,0.75,465.66,0.51,5.61,9.37,18,0.52,3.59,0.22,2.13,0.001,0.0003,170,0.001,22,0.28,0.23,0.08,0.09,4.4,0.261,4.4,1.3,94.48
carpio,17.28,1.24,821.81,0.77,10.32,14.45,13,0.75,2.58,0.16,1.80,0.001,0.001,190,0.002,2,6.6,0.63,0.12,0.06,5.8,0.18,15,1,68.85
koi,16.98,9.76,736.71,11.28,16.64,9.24,1,0.41,2.67,0.26,6.96,0.001,0.010,190,0.02,295,1.19,1,0.03,0.18,2.6,1,11.4,2.38,392.16
mola,16.67,4.4,583.5,9.87,19.39,28.39,17,0.28,2.31,0.28,6.12,0.001,0.006,1,0.02,2503,2.03,0.27,1,1,1,1,1,7.98,520.58
mrigel,18.04,1.02,459.9,0.93,6.68,6.61,15,0.61,3.52,0.20,2.19,0.001,0.0004,1,0.001,15,0.616,1,0.07,0.08,0.7,0.242,17,5.57,117.94
pangas,17.39,2.35,802.64,1.38,14.65,5.97,1,0.70,3.34,0.18,2.42,0.0004,0.001,1,0.01,5,1,1,0.15,0.06,4.5,0.107,1,1,144.39
pora_bele,16.76,0.78,439.74,4.44,4.6,10.32,31,0.41,2.65,0.20,3.42,0.001,0.001,210,0.03,37,22,0.55,1,1,1,1,3.7,1.4,70.21
puti,17.07,1.9,525.05,12.86,38.6,32.48,20,0.56,2.79,0.37,8.41,0.001,0.003,1,0.03,54,1.29,0.15,0.01,0.03,0.3,0.262,1,4.01,180.92
rui,18.87,2.24,507.17,0.54,4.31,5.89,20,0.31,3.79,0.24,2.26,0.001,0.001,200,0.002,13,1.17,0.12,0.05,0.07,5.9,0.112,1,5.05,286.19
shing,16.93,1.87,827.71,0.34,12.3,7.45,1,0.74,3.52,0.19,1.97,0.001,0.0003,230,0.002,32,1,0.34,0.08,0.09,0.6,0.261,1,12.8,84.23
shoal,18.46,0.63,466.15,0.30,4.28,6.3,1,0.43,3.79,0.23,2.09,0.001,0.001,260,0.0002,1,0.18,0.52,0.04,0.05,2,0.242,2.4,1.2,61.53
silver_carp,17.37,1.09,742.55,1.80,4.07,6.93,1,0.62,3.16,0.19,2.61,0.001,0.001,1,0.002,1,0.24,0.49,0.08,0.09,5,0.273,7.7,0.55,101.36
taki,18.58,1,674.53,1.01,3.55,5.75,18,0.32,3.30,0.19,2.00,0.001,0.001,1,0.005,139,1,0.14,0.04,0.05,2,0.244,1,1.6,94
tengra,15.69,5.27,518.75,3.59,14.75,12.43,1,0.34,2.98,0.21,3.44,0.001,0.001,1,0.002,43,1,1,0.01,0.04,5.4,0.296,1,1,217.99
sarpunti,18.1,2.86,532.71,0.65,5.28,3.99,38,0.23,3.32,0.19,1.89,0.001,0.0004,250,0.002,12,23,0.32,1,1,1,1,2.2,2.2,195.95
tilapia,18.71,2.17,873.1,0.27,4.14,4.82,1,0.44,2.55,0.16,1.32,0.001,0.001,1,0.002,2,5.5,0.71,0.97,0.09,8,0.111,24,1,229.83
bhangan,19.27,2.89,583.71,0.24,13.85,5.15,1,0.55,5.45,0.26,2.71,0.003,0.0004,1,0.001,1,1,0,1,1,1,1,1,1,509.5
bhola,11.3,0.7,299.88,4.67,6.83,6.46,1,0.34,1.25,0.15,3.21,0.0004,0.001,1,0.001,17,0.6,1.17,1,0.11,7.7,0.344,17,1,82.25
caine_magur,17.95,6.62,617.77,0.26,7.09,7.17,1,0.41,2.97,0.19,1.83,0.001,0.0004,1,0.001,1,1,1,1,1,1,1,1,1,487.08
datina,19.48,4.79,444.9,1.01,5.41,7.08,1,0.79,3.48,0.22,2.34,0.002,0.0004,1,0.0002,1,1,1,1,1,1,1,1,1,454.4
fesa,17.11,3,441.7,3.10,13.4,9.36,1,0.38,3.26,0.24,3.24,0.001,0.001,1,0.01,12,1,0.44,0.05,0.24,13,0.133,8,1,377.77
gaberdana,14.18,1.09,356.96,5.94,13.32,16.72,1,0.38,0.90,0.25,3.97,0.001,0.003,1,0.01,1,1,1,1,1,1,1,1,1,226.71
ilish,15.11,18.28,1010.13,1.96,8.57,5.5,37,0.27,2.69,0.14,2.23,0.001,0.001,210,0.002,20,18,1.7,0.12,0.14,5.6,1,1.5,2.3,1305.73
katkoi,19.57,4.79,767.89,0.50,1.2,2.7,1,0.19,0.53,0.03,0.49,0.0002,0.0001,1,0.001,1,1,1,1,1,1,1,1,1,647.43
khoira,17.96,1.07,892.25,7.49,10.44,14.48,1,0.68,2.90,0.33,5.84,0.001,0.002,1,0.003,1,1,1,1,1,1,1,1,1,147.26
khorshula,19.09,3.27,501.2,5.59,9.34,19.37,1,0.46,3.43,0.25,4.73,0.002,0.003,1,0.01,1,1,1,1,1,1,1,1,1,403.92
nona_tengra,17.88,5.11,539.5,6.37,41.22,17.59,1,0.33,2.01,0.23,4.41,0.001,0.002,1,0.01,1,1,1,1,1,1,1,1,1,355.63
parsey,17.51,7.42,969.39,1.04,11.98,7.79,1,1.32,4.72,0.30,2.95,0.001,0.001,1,0.002,1,1,1,0.1,0.11,0.8,0.328,1,1,598
payra,18.48,5.81,581.7,16.97,10.01,15.3,1,0.55,1.89,0.36,9.90,0.001,0.007,1,0.02,1,1,1,1,1,1,1,1,1,493.4
shilong,17.36,2.78,610.05,0.0001,0.01,0.08,1,0.70,0.35,0.19,2.28,0.004,0.004,1,0.0001,1,1,1,1,1,1,1,1,1,190.32
taposhi,17.35,1.78,655.42,0.97,2.91,3.15,1,0.23,1.86,0.11,1.38,0.001,0.001,1,0.001,1,1,1,1,1,1,1,1,1,153.47
koral,20.63,4,920.52,2.06,23.88,6.93,1,0.40,3.15,0.20,2.77,0.001,0.002,1,0.01,8,1,1,0.04,0.18,0.7,0.12,5,1,496.38
bagda,20.39,0.92,664.07,1.04,3.67,13.66,1,1.54,3.20,0.31,2.60,0.007,0.0005,1,0.001,1,1,1,1,1,1,1,1,1,85.5
chaka,19.86,1.16,475.66,0.60,15.94,11.94,1,1.18,3.16,0.33,2.81,0.005,0.002,1,0.01,1,1,1,1,1,1,1,1,1,108.61
chali,18.63,1.36,451.59,0.63,9.44,9.96,1,0.90,2.70,0.24,2.25,0.008,0.0004,1,0.003,1,1,1,1,1,1,1,1,1,136
goda,17.89,1.15,460.32,0.76,13.99,13.92,1,0.48,1.69,0.24,1.97,0.006,0.001,1,0.04,1,1,1,1,1,1,1,1,1,94.9
prawn,19.44,1.15,665.06,0.83,8.68,15.5,1,1.08,3.23,0.27,2.65,0.008,0.001,1,0.002,2,1,1,1,1,1,1,1,1,72.04
horina,18.83,1,430.73,0.95,11.55,18.54,26,1.90,4.04,0.47,3.55,0.008,0.001,190,0.001,1,0.055,1.6,1,1,1,1,14,1.4,79.38
kakra,15.2,2.57,366.85,8.38,112.17,51.11,1,2.77,3.67,0.63,2.71,0.014,0.020,1,0.04,1,1,1,1,1,1,1,1,1,257.91
rosna,16.78,1.17,451.94,1.83,8.63,11.97,1,0.92,1.19,0.22,1.28,0.013,0.001,1,0.02,1,1,1,1,1,1,1,1,1,127.97
shrimp,16.42,0.73,538.41,0.64,9.2,9.61,1,0.90,2.70,0.25,2.27,0.008,0.0004,1,0.003,1,1,1,1,1,1,1,1,1,102.66`;

// Parse function (inline for build-time execution)
function parseNutrientCsv(csvContent: string): Map<string, NutrientData> {
  const lines = csvContent.trim().split('\n');
  const nutrientMap = new Map<string, NutrientData>();
  
  // Skip header row
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;
    
    const values = line.split(',');
    
    if (values.length < 25) {
      console.warn(`Skipping malformed nutrient line ${i}: insufficient columns`);
      continue;
    }
    
    const fishId = values[0];
    
    const nutrients: NutrientData = {
      protein: { value: parseFloat(values[1]) || 0, unit: "g" },
      fat: { value: parseFloat(values[2]) || 0, unit: "g" },
      energy: { value: parseFloat(values[3]) || 0, unit: "kj" },
      calcium: { value: parseFloat(values[4]) || 0, unit: "mg" },
      iron: { value: parseFloat(values[5]) || 0, unit: "mg" },
      zinc: { value: parseFloat(values[6]) || 0, unit: "mg" },
      iodine: { value: parseFloat(values[7]) || 0, unit: "µg" },
      sodium: { value: parseFloat(values[8]) || 0, unit: "mg" },
      potassium: { value: parseFloat(values[9]) || 0, unit: "mg" },
      magnesium: { value: parseFloat(values[10]) || 0, unit: "mg" },
      phosphorus: { value: parseFloat(values[11]) || 0, unit: "mg" },
      copper: { value: parseFloat(values[12]) || 0, unit: "mg" },
      manganese: { value: parseFloat(values[13]) || 0, unit: "mg" },
      sulphur: { value: parseFloat(values[14]) || 0, unit: "mg" },
      selenium: { value: parseFloat(values[15]) || 0, unit: "µg" },
      vitaminA: { value: parseFloat(values[16]) || 0, unit: "µg RAE" },
      vitaminD: { value: parseFloat(values[17]) || 0, unit: "µg" },
      vitaminE: { value: parseFloat(values[18]) || 0, unit: "mg" },
      thiamin: { value: parseFloat(values[19]) || 0, unit: "mg" },
      riboflavin: { value: parseFloat(values[20]) || 0, unit: "mg" },
      niacin: { value: parseFloat(values[21]) || 0, unit: "mg" },
      vitaminB6: { value: parseFloat(values[22]) || 0, unit: "mg" },
      folate: { value: parseFloat(values[23]) || 0, unit: "µg" },
      vitaminB12: { value: parseFloat(values[24]) || 0, unit: "µg" },
      omega3: { value: parseFloat(values[25]) || 0, unit: "mg" },
    };
    
    nutrientMap.set(fishId, nutrients);
  }
  
  return nutrientMap;
}

// Parse CSV at module load time (build-time bundling)
export const nutrientDataMap: Map<string, NutrientData> = parseNutrientCsv(NUTRIENT_CSV_DATA);

/**
 * Get nutrient data for a specific fish by ID
 * @param fishId The fish identifier (e.g., "bheda", "katla")
 * @returns Nutrient data object or undefined if not found
 */
export function getNutrientData(fishId: string): NutrientData | undefined {
  return nutrientDataMap.get(fishId);
}

/**
 * Check if nutrient data exists for a fish ID
 */
export function hasNutrientData(fishId: string): boolean {
  return nutrientDataMap.has(fishId);
}
